/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Eu_Hosted_AltInputs */



/**
* | output |
* | --- |
* | "EU flag" |
*
* @param {Model_Eu_Hosted_AltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_eu_hosted_alt = /** @type {((inputs?: Model_Eu_Hosted_AltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Eu_Hosted_AltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("EU-Flagge")
	return /** @type {LocalizedString} */ ("EU flag")
});